import React from 'react';
import { useQuery } from '@apollo/client';
import GET_REVIEWS from 'gql/Reviews';
import ReviewCard from '@components/atoms/ReviewCard';
import { Box, Flex, Skeleton, Text } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

const bannermove = keyframes`
  0% {
    margin-left: 0px;
  }
  100% {
    margin-left: -2125px;
  }
`;

const Reviews = () => {
  const { loading, error, data } = useQuery(GET_REVIEWS, {
    fetchPolicy: 'no-cache',
  });

  const customerSurvey =
    loading || !data?.findDisplayReviews?.reviews?.length ? [1, 2, 3, 4, 5, 6] : data.findDisplayReviews.reviews;

  const animation = `${bannermove} 110s linear infinite`;

  if (data?.findDisplayReviews?.reviews) {
    return (
      <Box>
        <Text mb={[6, 4]} textStyle="h5" fontWeight={600}>
          Based on {data?.findDisplayReviews?.count} reviews, 96% of customers would recommend us to a friend.
        </Text>
        <Text textStyle="p">Here's what our clients say about us:</Text>
        <Flex animation={animation}>
          {customerSurvey.map((review, i) => (
            <Skeleton
              isLoaded={!loading}
              startColor="gray.100"
              endColor="gray.200"
              w={350}
              h={180}
              rounded="lg"
              m={5}
              key={i}
            >
              <ReviewCard review={review} />
            </Skeleton>
          ))}
        </Flex>
      </Box>
    );
  }

  return null;
};

export default Reviews;
